import {pauseFilledSvg as Icon__small__pauseFilledSvg} from '../Icon__small/Icon__small--pauseFilled.js';
import {pauseFilledSvg as Icon__xsmall__pauseFilledSvg} from '../Icon__xsmall/Icon__xsmall--pauseFilled.js';
import {pauseFilledSvg as Icon__xxsmall__pauseFilledSvg} from '../Icon__xxsmall/Icon__xxsmall--pauseFilled.js';

export var pauseFilled = {
  name: 'pauseFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__pauseFilledSvg,
  alt: {
    Icon__small: Icon__small__pauseFilledSvg,
    Icon__xsmall: Icon__xsmall__pauseFilledSvg,
    Icon__xxsmall: Icon__xxsmall__pauseFilledSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
